import { render, staticRenderFns } from "./ImageNews.vue?vue&type=template&id=f748d974&scoped=true"
import script from "./ImageNews.vue?vue&type=script&lang=js"
export * from "./ImageNews.vue?vue&type=script&lang=js"
import style0 from "./ImageNews.vue?vue&type=style&index=0&id=f748d974&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f748d974",
  null
  
)

export default component.exports